define('app/views/templates/helpers/showHistoryDining',['Handlebars'], function ( Handlebars ){
    function showHistoryDining(obj, block) {
        if(["WaitListQueued", 'Wait'].indexOf(obj.BookStatus) === -1) {
            return block.fn(this);
        }
    }

    Handlebars.registerHelper( 'showHistoryDining', showHistoryDining );
    return showHistoryDining;
});
